import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBalloon = () => {
  return (
    <g>
      <path d="M5.502 0c3.047 0 5.502 2.583 5.502 5.75 0 2.416-1.428 4.492-3.458 5.34l.653 1.631a.75.75 0 0 1-.593 1.022l-.103.007h-.846c.466.74 1.07.908 1.921.609l.147-.055c3.077-1.23 5.078-1.238 7.006.372a.75.75 0 1 1-.962 1.151c-1.417-1.183-2.868-1.178-5.487-.13-1.94.775-3.453.052-4.299-1.946l-1.482-.001a.75.75 0 0 1-.728-.93l.032-.099.653-1.63C1.428 10.24 0 8.166 0 5.75 0 2.583 2.454 0 5.502 0zm.58 11.469a5.337 5.337 0 0 1-1.16 0l-.313.781h1.785l-.312-.781zM5.502 1.5C3.3 1.5 1.5 3.394 1.5 5.75S3.3 10 5.5 10c2.202 0 4.002-1.894 4.002-4.25S7.703 1.5 5.502 1.5zm0 .75a.75.75 0 1 1 0 1.5c-.95 0-1.75.88-1.75 2a.75.75 0 0 1-1.501 0c0-1.918 1.439-3.5 3.25-3.5z" />
    </g>
  );
};

export default withIcon(IconBalloon);
